import {Component, OnInit} from '@angular/core';
import {Guard} from 'app/core/services/guard.service';
import {OrganizationDetailsService} from '../organization-details/organization-details.service';
import {RxComponent} from '../../../core/components/common/rx.component';
import {combineLatest} from "rxjs/observable/combineLatest";

@Component({
    selector: 'itpx-dashboard',
    templateUrl: './dashboard.component.html'
})
export class DashboardComponent extends RxComponent implements OnInit {
    private tiles: Array<any> = [
        {
            title: 'Organization Details',
            redirectPath: 'organization-details',
            description: 'Manage your Organization Details',
            icon: 'fa-ballot-check',
            color: 'orange'
        },
        {
            title: 'Users',
            redirectPath: 'users',
            description: 'Manage Your Users and Roles',
            icon: 'fa-users',
            color: 'orange'
        },
        {
            title: 'Certificate Templates',
            redirectPath: 'certificates',
            description: 'Manage Certificates Issued by your Company',
            icon: 'fa-file-certificate',
            color: 'orange',
        },
        {
            title: 'Credit Applications',
            redirectPath: 'credit',
            description: 'Apply for Credit to Purchase on Invoice',
            icon: 'fa-money',
            color: 'orange',
            permission: 'organization.credit-application'
        },
        {
            title: 'Communication',
            redirectPath: 'communications',
            description: 'Manage Your Outgoing Communication',
            icon: 'fa-inbox-out',
            color: 'orange',
            permission: 'solar'
        },
        {
            title: 'Venue Management',
            redirectPath: 'venues',
            description: 'Manage Your Class & Exam Venues',
            icon: 'fa-map-marker-alt',
            color: 'orange',
            permission: 'solar'
        }
    ];
    constructor(
        private guard: Guard,
        private organizationDetailService: OrganizationDetailsService
    ) {
        super();
    }

    ngOnInit() {
        combineLatest(this.organizationDetailService.checkIfBuyerOnInvoice(), this.organizationDetailService.isBuyerAvailableForConsumptionVouchers())
            .subscribe(
                ([isInInvoice, isAvailableForConsumptionVouchers]) => {
                    if (isInInvoice.data || isAvailableForConsumptionVouchers.data) {
                        this.tiles.push(
                            {
                                title: 'Approvals',
                                redirectPath: 'approvals',
                                description: 'Manage Approval Settings',
                                icon: 'fa-file-check',
                                color: 'orange',
                                permission: 'buyerApproval'
                            },
                        )
                    }
                });
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/dashboard/dashboard.component.ts